/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowThread200ResponseDataUser } from './ShowThread200ResponseDataUser';
import {
    ShowThread200ResponseDataUserFromJSON,
    ShowThread200ResponseDataUserFromJSONTyped,
    ShowThread200ResponseDataUserToJSON,
    ShowThread200ResponseDataUserToJSONTyped,
} from './ShowThread200ResponseDataUser';

/**
 * 
 * @export
 * @interface ShowUser200Response
 */
export interface ShowUser200Response {
    /**
     * 
     * @type {ShowThread200ResponseDataUser}
     * @memberof ShowUser200Response
     */
    data?: ShowThread200ResponseDataUser;
}

/**
 * Check if a given object implements the ShowUser200Response interface.
 */
export function instanceOfShowUser200Response(value: object): value is ShowUser200Response {
    return true;
}

export function ShowUser200ResponseFromJSON(json: any): ShowUser200Response {
    return ShowUser200ResponseFromJSONTyped(json, false);
}

export function ShowUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowUser200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ShowThread200ResponseDataUserFromJSON(json['data']),
    };
}

export function ShowUser200ResponseToJSON(json: any): ShowUser200Response {
    return ShowUser200ResponseToJSONTyped(json, false);
}

export function ShowUser200ResponseToJSONTyped(value?: ShowUser200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShowThread200ResponseDataUserToJSON(value['data']),
    };
}

